import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { TotalCheckRollSummaryReportListing } from './Pages'

export const TotalCheckRollSummaryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={TotalCheckRollSummaryReportListing} />
    </Fragment>
)